import { NavLink } from "react-router";

import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";

import { styleConst } from "../../utils/style";

const SocialLink = ({ socialIcon, href }) => {
  const Icon = socialIcon;
  return (
    <a href={href} target="_blank" rel="noreferrer">
      <Icon sx={{ fontSize: "2.5rem", color: styleConst.pgbackground }} />
    </a>
  );
};

const Footer = () => {
  return (
    <div style={styles.container}>
      <div style={styles.sectionsContainer}>
        <div style={styles.section}>
          <img
            loading="lazy"
            alt="association pour guillaume"
            src={require("../../assets/generic/images/logo-w-nobg.png")}
            style={{
              maxWidth: window.screen.width < 600 ? "80%" : "50%",
              marginBottom: 5,
            }}
          />
          <p
            style={{
              color: "white",
              fontSize: window.screen.width < 600 ? 8 : 14,
              display: "inline-block",
              maxWidth: "100%",
              textAlign: "left",
              whiteSpace: "normal",
            }}
          >
            Association "Pour Guillaume",
            <br />
            Le Domaine,
            <br />
            05500 Saint-Bonnet
          </p>
        </div>
        <div style={{ ...styles.section, position: "relative" }}>
          <div style={{ ...styles.verticalDivider, left: 0 }}></div>
          <div style={{ ...styles.verticalDivider, right: 0 }}></div>
          <div style={styles.linkContainer}>
            <NavLink style={styles.navLink} to={"/"}>
              Accueil
            </NavLink>
            <NavLink style={styles.navLink} to={"/association"}>
              Association
            </NavLink>
            <NavLink style={styles.navLink} to={"/tournoi"}>
              Tournoi
            </NavLink>
            <NavLink style={styles.navLink} to={"/inscription"}>
              Inscription
            </NavLink>
            <NavLink style={styles.navLink} to={"/historique/2026"}>
              Photos
            </NavLink>
            <NavLink style={styles.navLink} to={"/partenaires"}>
              Partenaires
            </NavLink>
          </div>
        </div>
        <div style={styles.section}>
          <p
            style={{
              color: "white",
              fontSize: window.screen.width < 600 ? 12 : 20,
              marginBottom: window.screen.width < 600 ? 2 : 10,
            }}
          >
            Nous contacter : <br />
          </p>
          <a href="mailto:assopourguillaume@gmail.com" style={styles.contact}>
            assopourguillaume@gmail.com
          </a>
          <a href="tel:+33670636502" style={styles.contact}>
            0670636502
          </a>
          <p
            style={{
              color: "white",
              fontSize: window.screen.width < 600 ? 12 : 20,
              marginTop: 10,
            }}
          >
            Nous suivre : <br />
          </p>
          <div style={{ marginTop: 10 }}>
            <SocialLink
              socialIcon={InstagramIcon}
              href={
                "https://www.instagram.com/associationpourguillaume?igsh=MXByZWM5YmY1NnFleA=="
              }
            />
            <SocialLink
              socialIcon={FacebookIcon}
              href={"https://www.facebook.com/366364753427007?ref=embed_page"}
            />
          </div>
        </div>
      </div>
      <div style={styles.horizontalDivider}></div>
      <div style={styles.bottomContainer}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <NavLink
            style={{
              color: "white",
              listStyleType: "none",
              cursor: "pointer",
              textDecoration: "none",
              fontSize: window.screen.width < 600 ? 8 : 12,
              marginRight: 3,
            }}
            to={"/mentions-legales"}
          >
            Mentions Légales{" "}
          </NavLink>
          <span
            style={{
              color: "white",
              fontSize: window.screen.width < 600 ? 8 : 12,
            }}
          >
            <a
              style={{ color: "inherit", textDecoration: "none" }}
              href="https://www.linkedin.com/in/floran-eiclies/"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              | © Floran Eiclies{" "}
            </a>
            <a
              style={{
                color: "inherit",
                textDecoration: "none",
                marginRight: 3,
              }}
              href="https://www.linkedin.com/in/romain-moullet-634606216/"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              & Romain Moullet
            </a>
            - Tous droits réservés - 2026
          </span>
        </div>
      </div>
    </div>
  );
};

const styles = {
  bottomContainer: {
    position: "absolute",
    bottom: 5,
    left: "50%",
    transform: "translateX(-50%)",
    width: "80%",
    height: "2rem",
  },
  contact: {
    color: styleConst.pgbackground,
    textDecoration: "none",
    fontSize: window.screen.width < 600 ? 8 : 14,
  },
  container: {
    backgroundColor: styleConst.primaryColor,
    height: "15rem",
    width: window.screen.width < 600 ? "100%" : "calc(100% - 14rem)",
    marginLeft: window.screen.width < 600 ? 0 : "14rem",
    display: "flex",
    justifyContent: "center",
    position: "relative",
  },
  horizontalDivider: {
    position: "absolute",
    bottom: 50,
    left: "50%",
    transform: "translateX(-50%)",
    width: "80%",
    height: 1,
    background: "rgba(143, 149, 149, 0.4)",
  },
  linkContainer: {
    height: "100%",
    width: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    position: "relative",
  },
  navLink: {
    color: "white",
    listStyleType: "none",
    cursor: "pointer",
    textDecoration: "none",
  },
  section: {
    height: "100%",
    width: "30%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  sectionsContainer: {
    height: "10rem",
    width: window.screen.width < 600 ? "100%" : "80%",
    display: "flex",
    justifyContent: "space-around",
  },
  verticalDivider: {
    position: "absolute",
    top: "10%",
    height: "80%",
    width: "2px",
    backgroundColor: "rgba(143, 149, 149, 0.4)",
  },
};

export default Footer;
